import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";

const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingHorizontal: 20,
    paddingBottom: 48,
    fontSize: 6,
    flexDirection: "column",
    position: "relative",
    color: "#252525",
    flex: 1,
  },

  logoContainer: {
    marginBottom: 6,
  },

  logo: {
    width: 120,
  },

  titleContainer: {
    alignItems: "center",
    marginBottom: 15,
  },

  titleText: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    color: "#328AC4",
  },

  orderText: {
    fontSize: 8,
    color: "#666666",
    marginTop: 3,
  },

  sectionTitle: {
    marginTop: 5,
    marginBottom: 4,
    paddingBottom: 2,
    borderBottom: "0.7pt solid #328AC4",
  },

  subTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#328AC4",
  },

  table: {
    marginBottom: 9,
    border: "0.7pt solid #D5DCE3",
    borderRadius: 3,
    overflow: "hidden",
  },

  tableHeader: {
    backgroundColor: "#EEF3F7",
    flexDirection: "row",
    paddingVertical: 4,
    paddingHorizontal: 2,
    borderBottom: "0.5pt solid #D5DCE3",
  },

  tableRow: {
    flexDirection: "row",
    paddingVertical: 4,
    paddingHorizontal: 2,
    borderBottom: "0.3pt solid #E8E8E8",
  },

  emptyText: {
    fontSize: 7,
    color: "#777777",
    fontStyle: "italic",
    padding: 6,
  },

  // Cliente
  colRut: {
    width: "12%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colNombre: {
    width: "20%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colFecha: {
    width: "16%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colTelefono: {
    width: "12%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colDireccion: {
    width: "20%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colEmail: {
    width: "20%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colNacimiento: {
    width: "12%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  // Equipo
  colFamilia: {
    width: "18%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colTipo: {
    width: "22%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colMarca: {
    width: "13%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colModelo: {
    width: "16%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colSerie: {
    width: "13%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colServicio: {
    width: "14%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colHora: {
    width: "4%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  // Tablas técnicas
  colIndex: {
    width: "5%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colItem: {
    width: "70%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  colResultado: {
    width: "25%",
    textAlign: "center",
    paddingHorizontal: 4,
  },

  colInstrumento: {
    width: "95%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  colMedItem: {
    width: "50%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  colMedValor: {
    width: "20%",
    textAlign: "center",
    paddingHorizontal: 4,
  },

  colMedUnidad: {
    width: "25%",
    textAlign: "center",
    paddingHorizontal: 4,
  },

  colSegItem: {
    width: "70%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  colSegResultado: {
    width: "25%",
    textAlign: "center",
    paddingHorizontal: 4,
  },

  observationSection: {
    marginTop: 4,
    padding: 6,
    border: "0.8pt solid #D5DCE3",
    borderRadius: 3,
    backgroundColor: "#FAFAFA",
  },

  observationTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#328AC4",
    marginBottom: 5,
  },

  observationText: {
    fontSize: 8,
    lineHeight: 1.5,
    textAlign: "justify",
  },

  signatureSection: {
    marginTop: 12,
    flexDirection: "row",
    justifyContent: "flex-end",
  },

  signatureBox: {
    width: 190,
    alignItems: "center",
  },

  signatureLine: {
    width: 160,
    borderTop: "0.8pt solid #555555",
    marginBottom: 5,
  },

  signatureName: {
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "center",
  },

  signatureRole: {
    fontSize: 7,
    marginTop: 2,
    textAlign: "center",
  },

  signatureArea: {
    fontSize: 7,
    color: "#666666",
    marginTop: 1,
    textAlign: "center",
  },

  footer: {
    position: "absolute",
    bottom: 14,
    left: 20,
    right: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 6.5,
    color: "#777777",
    borderTop: "0.5pt solid #DDDDDD",
    paddingTop: 4,
  },

  footerContact: {
    width: "80%",
  },

  footerPage: {
    width: "20%",
    textAlign: "right",
  },
});

const MantoPDF = ({
  cabecera = [],
  itemsInst = [],
  itemsCheck = [],
  itemsMed = [],
  itemsSeg = [],
  usuario = [],
  empresa = "",
  obs = "",
}) => {
  const ingreso = cabecera?.[0] || {};
  const tecnico = usuario?.[0];

  const nombreTecnico = tecnico
    ? `${tecnico.nombre || ""} ${tecnico.apellido || ""}`.trim()
    : "Técnico no informado";

  return (
    <Document>
      <Page size="LETTER" style={styles.page}>
        {/* Logo */}
        {empresa && (
          <View style={styles.logoContainer}>
            <Image
              src={`../../${empresa}.png`}
              style={styles.logo}
            />
          </View>
        )}

        {/* Título */}
        <View style={styles.titleContainer}>
          <Text style={styles.titleText}>
            Certificado de Mantención Preventiva
          </Text>

          {ingreso?.folio && (
            <Text style={styles.orderText}>
              Orden de servicio N° {ingreso.folio}
            </Text>
          )}
        </View>

        {/* Información cliente */}
        <View style={styles.sectionTitle}>
          <Text style={styles.subTitle}>
            Información del cliente
          </Text>
        </View>

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.colRut}>RUT</Text>
            <Text style={styles.colNombre}>Nombre</Text>
            <Text style={styles.colFecha}>Fecha</Text>
            <Text style={styles.colTelefono}>Teléfono</Text>
            <Text style={styles.colDireccion}>Dirección</Text>
            <Text style={styles.colEmail}>Email</Text>
            <Text style={styles.colNacimiento}>F. Nac.</Text>
          </View>

          {cabecera.length > 0 ? (
            cabecera.map((p, i) => (
              <View
                style={styles.tableRow}
                key={p.id || i}
              >
                <Text style={styles.colRut}>
                  {p.rut || ""}
                </Text>

                <Text style={styles.colNombre}>
                  {p.entidad || ""}
                </Text>

                <Text style={styles.colFecha}>
                  {formatearFecha(p.date)}
                </Text>

                <Text style={styles.colTelefono}>
                  {p.telefono || ""}
                </Text>

                <Text style={styles.colDireccion}>
                  {p.direccion || ""}
                </Text>

                <Text style={styles.colEmail}>
                  {p.correo || ""}
                </Text>

                <Text style={styles.colNacimiento}>
                  {p.fnaci
                    ? formatearFecha(p.fnaci, false)
                    : "------"}
                </Text>
              </View>
            ))
          ) : (
            <Text style={styles.emptyText}>
              No se encontró información del cliente.
            </Text>
          )}
        </View>

        {/* Información equipo */}
        <View style={styles.sectionTitle}>
          <Text style={styles.subTitle}>
            Información del equipo
          </Text>
        </View>

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.colFamilia}>Familia</Text>
            <Text style={styles.colTipo}>Tipo</Text>
            <Text style={styles.colMarca}>Marca</Text>
            <Text style={styles.colModelo}>Modelo</Text>
            <Text style={styles.colSerie}>Serie</Text>
            <Text style={styles.colServicio}>Servicio</Text>
            <Text style={styles.colHora}>Hora</Text>
          </View>

          {cabecera.length > 0 ? (
            cabecera.map((e, i) => (
              <View
                style={styles.tableRow}
                key={`equipo-${e.id || i}`}
              >
                <Text style={styles.colFamilia}>
                  {e.familia || ""}
                </Text>

                <Text style={styles.colTipo}>
                  {e.tipo || ""}
                </Text>

                <Text style={styles.colMarca}>
                  {e.marca || ""}
                </Text>

                <Text style={styles.colModelo}>
                  {e.modelo || ""}
                </Text>

                <Text style={styles.colSerie}>
                  {e.serie || ""}
                </Text>

                <Text style={styles.colServicio}>
                  {e.servicio || ""}
                </Text>

                <Text style={styles.colHora}>
                  {e.horamaquina ?? ""}
                </Text>
              </View>
            ))
          ) : (
            <Text style={styles.emptyText}>
              No se encontró información del equipo.
            </Text>
          )}
        </View>

        {/* Instrumentos */}
        {itemsInst.length > 0 && (
          <>
            <View style={styles.sectionTitle}>
              <Text style={styles.subTitle}>
                Instrumentos utilizados
              </Text>
            </View>

            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={styles.colIndex}>N°</Text>
                <Text style={styles.colInstrumento}>
                  Instrumento
                </Text>
              </View>

              {itemsInst.map((item, i) => (
                <View
                  style={styles.tableRow}
                  key={item.id || item.item_id || i}
                >
                  <Text style={styles.colIndex}>
                    {i + 1}
                  </Text>

                  <Text style={styles.colInstrumento}>
                    {item.item || ""}
                  </Text>
                </View>
              ))}
            </View>
          </>
        )}

        {/* Checklist */}
        {itemsCheck.length > 0 && (
          <>
            <View style={styles.sectionTitle}>
              <Text style={styles.subTitle}>
                Verificaciones realizadas
              </Text>
            </View>

            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={styles.colIndex}>N°</Text>
                <Text style={styles.colItem}>
                  Verificación
                </Text>
                <Text style={styles.colResultado}>
                  Resultado
                </Text>
              </View>

              {itemsCheck.map((item, i) => (
                <View
                  style={styles.tableRow}
                  key={item.id || item.item_id || i}
                >
                  <Text style={styles.colIndex}>
                    {i + 1}
                  </Text>

                  <Text style={styles.colItem}>
                    {item.item || ""}
                  </Text>

                  <Text style={styles.colResultado}>
                    {item.valor ?? ""}
                  </Text>
                </View>
              ))}
            </View>
          </>
        )}

        {/* Mediciones */}
        {itemsMed.length > 0 && (
          <>
            <View style={styles.sectionTitle}>
              <Text style={styles.subTitle}>
                Mediciones efectuadas
              </Text>
            </View>

            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={styles.colIndex}>N°</Text>

                <Text style={styles.colMedItem}>
                  Medición
                </Text>

                <Text style={styles.colMedValor}>
                  Resultado
                </Text>

                <Text style={styles.colMedUnidad}>
                  Unidad
                </Text>
              </View>

              {itemsMed.map((item, i) => (
                <View
                  style={styles.tableRow}
                  key={item.id || item.item_id || i}
                >
                  <Text style={styles.colIndex}>
                    {i + 1}
                  </Text>

                  <Text style={styles.colMedItem}>
                    {item.item || ""}
                  </Text>

                  <Text style={styles.colMedValor}>
                    {item.valor ?? ""}
                  </Text>

                  <Text style={styles.colMedUnidad}>
                    {item.medida || ""}
                  </Text>
                </View>
              ))}
            </View>
          </>
        )}

        {/* Seguridad */}
        {itemsSeg.length > 0 && (
          <>
            <View style={styles.sectionTitle}>
              <Text style={styles.subTitle}>
                Verificaciones de seguridad
              </Text>
            </View>

            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={styles.colIndex}>N°</Text>

                <Text style={styles.colSegItem}>
                  Verificación
                </Text>

                <Text style={styles.colSegResultado}>
                  Resultado
                </Text>
              </View>

              {itemsSeg.map((item, i) => (
                <View
                  style={styles.tableRow}
                  key={item.id || item.item_id || i}
                >
                  <Text style={styles.colIndex}>
                    {i + 1}
                  </Text>

                  <Text style={styles.colSegItem}>
                    {item.item || ""}
                  </Text>

                  <Text style={styles.colSegResultado}>
                    {item.valor ?? ""}
                  </Text>
                </View>
              ))}
            </View>
          </>
        )}

        {/* Observaciones */}
        <View style={styles.observationSection}>
          <Text style={styles.observationTitle}>
            Observaciones y recomendaciones
          </Text>

          <Text style={styles.observationText}>
            {obs?.trim() ||
              "No se registraron observaciones adicionales."}
          </Text>
        </View>

        {/* Firma */}
        <View style={{ flexGrow: 1 }} />

        <View
          style={styles.signatureSection}
          wrap={false}
        >
          <View
            style={styles.signatureBox}
            wrap={false}
          >
            <View style={styles.signatureLine} />

            <Text style={styles.signatureName}>
              {nombreTecnico.toUpperCase()}
            </Text>

            <Text style={styles.signatureRole}>
              Técnico responsable
            </Text>

            <Text style={styles.signatureArea}>
              Servicio Técnico
            </Text>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer} fixed>
          <Text style={styles.footerContact}>
            soporte@dormirbien.cl | General Parra #674 Oficina H,
            Providencia | +56 9 7632 1481 / +56 9 5423 4538
          </Text>

          <Text
            style={styles.footerPage}
            render={({ pageNumber, totalPages }) =>
              `Página ${pageNumber} de ${totalPages}`
            }
          />
        </View>
      </Page>
    </Document>
  );
};

const formatearFecha = (fecha, incluirHora = true) => {
  if (!fecha) return "------";

  try {
    let dateObj;

    if (typeof fecha?.toDate === "function") {
      dateObj = fecha.toDate();
    } else if (fecha instanceof Date) {
      dateObj = fecha;
    } else {
      dateObj = new Date(fecha);
    }

    if (Number.isNaN(dateObj.getTime())) {
      return "------";
    }

    return moment(dateObj).format(
      incluirHora
        ? "DD/MM/YYYY HH:mm"
        : "DD/MM/YYYY"
    );
  } catch (error) {
    console.error("Error al formatear fecha:", error);
    return "------";
  }
};

export default MantoPDF;